// import Swiper bundle with all modules installed
//import Swiper from 'swiper/bundle';

// import styles bundle
//import 'swiper/css/bundle';

const swiperHomepage = {

    init () {

        let homePage = document.getElementById('homepage');
        if(homePage){
            // init Swiper:
            const swiper = new Swiper('.swiper', {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
            
                // If we need pagination
                pagination: {
                el: '.swiper-pagination',
                },
        
                autoplay: {
                    delay: 5000,
                },
                
                speed: 1800,

                // Navigation arrows
                navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                },
            
                // And if we need scrollbar
                scrollbar: {
                el: '.swiper-scrollbar',
                },

            });
           
        }
            
    }

}

export default swiperHomepage;